// extracted by mini-css-extract-plugin
export default {"mainContainer":"ClassNameEditor_mainContainer__V7JC8","autocomplete":"ClassNameEditor_autocomplete__t1-UF"};